export const AUTH_URL = '/api/auth'
export const GEN_IRN = '/api/Invoice';
export const CAN_IRN = '/api/Cancel'
export const GET_IRN = `/api/Invoice/irn/`
